// @flow
export const devModeEnabled = (): boolean => Boolean(window.__DEV_MODE__);
